// src/components/Checkout/PaypalBox.js
import React, { useEffect, useState, useMemo } from "react";
import { Typography } from "@mui/material";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";

const PaypalBox = ({ cartItems, setCartItems, txId }) => {
  const navigate = useNavigate();
  const [clientId, setClientId] = useState("");

  useEffect(() => {
    fetch("/ecommerce/api/paypal/client/")
      .then((r) => r.json())
      .then((d) => setClientId(d.client_id || ""))
      .catch(() => setClientId(""));
  }, []);

  const total = useMemo(() => {
    return cartItems
      .reduce(
        (s, it) =>
          s +
          Number(it.price_with_iva ?? it.price ?? it.unitPrice ?? 0) *
            it.quantity,
        0
      )
      .toFixed(2);
  }, [cartItems]);

  const sendToBackend = async (orderId, itemsPayload) => {
    const payload = {
      order_id: orderId,
      amount: Number(total),
      items: itemsPayload,
    };

    await fetch("/ecommerce/api/paypal/init/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": document.cookie.replace(
          /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
          "$1"
        ),
      },
      credentials: "include",
      body: JSON.stringify(payload),
    });
  };

  const onApproveStore = async (details) => {
    const orderId = details?.id || "";

    const itemsPayload = cartItems.map((it) => ({
      id: it.id,
      name: it.name,
      quantity: it.quantity,
      price: Number(it.price_with_iva ?? it.price ?? 0),
      brand: it.brand || it.marca || "",
      reference: it.code || it.reference || "",
      sku: it.sku || "",
      variant: it.variant || null,
      section: it.section || "",
      category: it.category || "",
      slug: it.slug || "",
    }));

    await sendToBackend(orderId, itemsPayload);

    const orderData = {
      gateway: "paypal",
      order_id: orderId,
      reference: txId,
      status: "Completed",
      amount: total,
      items: itemsPayload,
      payer: {
        name: details?.payer?.name?.given_name || "",
        email: details?.payer?.email_address || "",
      },
      created_at: new Date().toISOString(),
    };

    localStorage.setItem("lastOrder", JSON.stringify(orderData));
    localStorage.removeItem("cart");
    localStorage.removeItem("cartItems");

    setCartItems([]);

    navigate(
      `/checkout/exito?gateway=paypal&order_id=${encodeURIComponent(orderId)}`
    );
  };

  if (!clientId) return <div>Cargando PayPal...</div>;

  return (
    <PayPalScriptProvider options={{ "client-id": clientId, currency: "USD" }}>
      <div className="paypal-box">
        <Typography fontWeight="bold" sx={{ mb: 1 }}>
          Pago con PayPal
        </Typography>

        <PayPalButtons
          disabled={cartItems.length === 0}
          style={{ layout: "vertical" }}
          createOrder={(data, actions) =>
            actions.order.create({
              purchase_units: [
                {
                  amount: { value: Number(total).toFixed(2) },
                  description: `Compra de ${cartItems.length} producto(s)`,
                },
              ],
            })
          }
          onApprove={(data, actions) =>
            actions.order.capture().then((details) => onApproveStore(details))
          }
        />
      </div>
    </PayPalScriptProvider>
  );
};

export default PaypalBox;
